export default {
    resetScreen: () => {
		window.scrollTo(0, 0);
    },
    currencyFormatter: (value, format = 100) => {
        if (!Number(value)) return '';

        const amount = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(value / format);

        return `${amount}`;
    },
	floatToCurrency: value => value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
	intToCurrency: value => `R$ ${value},00`,
    currencyToFloat: (value) => {
        const valueNumber = value.substring(3)
            .replace('.', '')
            .replace(',', '.');

        return parseFloat(valueNumber);
    },
    basePath: () => {
        const domain = window.location.host;
        return domain.includes('webmotors') ? '' : '/campaigns';
    },
};
